import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import Image from '../../../../atoms/Image';
import SocialMedia from '../../../../molecules/SocialMedia';
import Copyright from '../../../../molecules/CopyrightLabel';

const SubscriptionBannerFooter = props => {
  const { bottomColor, socialMedia, copyright, logo } = props;
  return (
    <Grid
      centered
      style={{ backgroundColor: bottomColor, paddingTop: '1.2em', paddingBottom: '1.2em' }}
    >
      <Grid.Column computer={1} tablet={1} only="computer tablet" />
      <Grid.Column
        computer={4}
        tablet={5}
        verticalAlign="middle"
        textAlign="left"
        only="computer tablet"
      >
        <SocialMedia socialMediaValues={socialMedia} buttonType="rect" />
      </Grid.Column>
      <Grid.Column mobile={14} textAlign="center" only="mobile">
        <SocialMedia socialMediaValues={socialMedia} buttonType="rect" />
      </Grid.Column>
      <Grid.Column computer={6} tablet={4} mobile={14} verticalAlign="middle" textAlign="center">
        <Copyright company={copyright.company} phrase={copyright.phrase} />
      </Grid.Column>
      <Grid.Column computer={2} tablet={1} only="computer tablet" />
      <Grid.Column
        computer={2}
        tablet={4}
        verticalAlign="middle"
        textAlign="right"
        only="computer tablet"
      >
        <Image src={logo} size="medium" />
      </Grid.Column>
      <Grid.Column mobile={8} textAlign="center" only="mobile">
        <Image src={logo} size="medium" />
      </Grid.Column>
      <Grid.Column computer={1} tablet={1} only="computer tablet" />
    </Grid>
  );
};

SubscriptionBannerFooter.propTypes = {
  bottomColor: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
};

export default SubscriptionBannerFooter;
